// Game-module shim (unify Phase 3/4): resolves to the active game's hero roster.
// Every game has its own roster module; hok/lol otherwise reuse the dota
// component implementations.
import game from '../games';
const impl =
  game.id === 'mlbb' ? require('../games/mlbb/models/HeroData') :
  game.id === 'hok'  ? require('../games/hok/models/HeroData') :
  game.id === 'lol'  ? require('../games/lol/models/HeroData') :
  require('../games/dota/models/HeroData');
export const HeroData = impl.HeroData;
export default impl.default;
